<template>
  <v-expansion-panel>
    <v-expansion-panel-header>
      <v-row>
        <v-col
          cols="12"
          md="1"
        >
          <ms-icons
            :ms-id="1"
            height="40"
            width="40"
            class="text-haunter"
          />
        </v-col>
        <v-col
          cols="12"
          md="11"
          class="d-flex align-center"
        >
          <span>Pruebas Psicométricas</span>
        </v-col>
      </v-row>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <settings-ks :current-user="currentUser" />
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import SettingsKs from '../../../../keyscoring/settings_keyscoring/settings-ks.vue';
import MsIcons from '@app/components/MicroserviceIcon.vue'

export default {
  components: {
    SettingsKs,
    MsIcons,
  },
  props: {
    currentUser: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style>

</style>
